import React from "react";
import { Controller } from "react-hook-form";
import { Col, Input, Label, Row } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";

interface ControlledTextFieldProps {
    label?: string;
    inputName: string;
    inputType: string;
    placeholder?: string;
    invalid?: boolean;
    control: any;
    rules?: object;
    errors?: object;
    register?: any;
    isRequired?: boolean;
    hasSideLabel?: boolean;
    sideLabel?: string;
    isDisabled?: boolean;
    defaultValue?: string;
    className?: string;
    value?: string | FileList;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    multiple?: boolean;
    autoComplete?: string;
}

type MyInputType =
    | "text"
    | "email"
    | "password"
    | "number"
    | "tel"
    | "url"
    | "search"
    | "date"
    | "datetime-local"
    | "time"
    | "week"
    | "month"
    | "color"
    | "file";

const ControlledRowTextField: React.FC<ControlledTextFieldProps> = ({
    label,
    inputName,
    inputType,
    placeholder,
    invalid,
    control,
    rules,
    errors,
    register,
    isRequired,
    hasSideLabel,
    sideLabel,
    isDisabled,
    defaultValue,
    className,
    onChange,
    autoComplete
}) => {
    return (
        <div className="my-1">
            <Row>
                <Col lg="4">
                    <Label className={`pt-1 form-label`} htmlFor={inputName}>
                        {isRequired ? `${label}*` : label}
                    </Label>
                </Col>
                <Col lg="8">
                    <Controller
                        name={inputName}
                        control={control}
                        rules={rules}
                        render={({ field }) => (
                            <Input
                                id={inputName}
                                type={inputType as MyInputType}
                                autoComplete={autoComplete}
                                placeholder={placeholder}
                                invalid={invalid}
                                disabled={isDisabled}
                                {...field}
                                defaultValue={defaultValue}
                                className={className}
                                required={isRequired}
                                step={inputType === "number" ? "any" : undefined}
                                multiple={inputType === "file" ? true : undefined}
                                onChange={(e) => {
                                    field.onChange(e);
                                    if (onChange) {
                                        onChange(e);
                                    }
                                }}

                            />
                        )}
                    />
                    {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
                    {invalid && (
                        <ValidationMsgComponent
                            inputName={inputName}
                            invalid={invalid}
                            errors={errors}
                            rules={rules}
                        />
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default ControlledRowTextField;
